import * as React from 'react'

import { Alert, Box, Button, TextBody, upToMd } from '@ally/metronome-ui'
import { Forms, Form, TextInput } from '@ally/forms'
import { FormField, LoginHeading } from '@ally/ally-login'

import { InputWrapper } from '../Shared'

export const LOAN_NUMBER_PATTERN = /^\d{10}$/

const LoanVerificationFailed: React.FC = () => (
  <Alert
    variant="error"
    heading="Hmm. We’re having trouble verifying your loan information."
    body="Double-check your 10-digit loan number, or give us a call for assistance."
    focusOnMount
  />
)

interface VerifyMortgageFormProps {
  formId: string
}

const VerifyMortgageForm: React.FC<VerifyMortgageFormProps> = ({ formId }) => {
  const validateLoanNumber = (loanNumber: string): string | undefined => {
    if (!loanNumber) {
      return 'Enter Loan Number to continue.'
    }

    if (!LOAN_NUMBER_PATTERN.test(loanNumber)) {
      return 'Enter a valid Loan Number.'
    }

    return undefined
  }

  return (
    <Form id={formId}>
      <FormField>
        <InputWrapper mb="md">
          <TextInput
            labelContent="Loan number"
            name="loanNumber"
            inputType="number"
            validate={validateLoanNumber}
            data-testid="enroll-verify-loan-number"
          />
        </InputWrapper>
      </FormField>

      <Button
        text="Continue"
        fullWidthMd
        type="submit"
        variant="primary"
        allytmln="continue"
      />
    </Form>
  )
}

export const VerifyMortgage: React.FC = () => {
  const formId = 'enroll-verify-mortgage'
  const initialValues = { loanNumber: '' }
  const [verificationFailed, setVerificationFailed] = React.useState<boolean>(
    false,
  )
  const handleSubmit = (): void => {
    // TODO: replace with actual submit logic
    setVerificationFailed(true)
  }
  // const { hostServices } = useTransmit()

  // React.useEffect(() => {
  //   hostServices?.analytics.trackPageView({
  //     eventType: 'pageview',
  //     pageName: '<TBD>',
  //   })
  // }, [])

  return (
    <>
      <LoginHeading title="Verify your loan number so we know it’s you." />

      <Box mb="sm" display="flex" width={upToMd<any, any>(12, 6) as any}>
        <TextBody tag="p" size="md" data-testid="enroll-verify-subcopy">
          You can find your 10-digit loan number on your monthly statement or on
          the official notice of loan transfer to us.
        </TextBody>
      </Box>

      <Forms
        formId={formId}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {verificationFailed && <LoanVerificationFailed />}

        <VerifyMortgageForm formId={formId} />
      </Forms>
    </>
  )
}
